'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import { LineItem } from '@repo/ui/src/types/lineItem';
import { GiftCard } from '@repo/ui/src/types/basket';
import { useCurrencyString } from '@hooks/useCurrencyString';
import { isGiftCard } from '@models/lineItem';

interface Props {
  item: LineItem | GiftCard;
  editable?: boolean;
}

const ProductPricing = ({ item, editable }: Props) => {
  const createCurrencyString = useCurrencyString();
  const fontColor = editable ? 'tw-text-neutral-500' : 'tw-text-neutral-400';

  const isGC = isGiftCard(item);
  if (!isGC && item.bonus) {
    return (
      <p className={classNames('tra-text-web-body-m tw-text-left tw-mb-0', fontColor)}>FREE</p>
    );
  }

  return (
    <p
      className={classNames(
        'tra-text-web-body-m tw-text-right tw-mb-0 tw-flex tw-flex-col',
        fontColor,
      )}
    >
      <span className="sr-only">Current price: </span>
      {createCurrencyString(isGC ? item.amount : item.price)}

      {!isGC && item.hasDiscount && (
        <>
          <span className="sr-only">Original price: </span>
          <span className="tw-line-through tw-text-neutral-200">
            {createCurrencyString(item.originalPrice)}
          </span>
        </>
      )}
    </p>
  );
};

export default ProductPricing;
